module.exports = __webpack_public_path__ + "f02504834499de04fc73f2571478cef9.svg";